import "@/index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/lib/auth";
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/Auth";
import Dashboard from "@/pages/Dashboard";
import AtmLocator from "@/pages/AtmLocator";
import Status from "@/pages/Status";
import MerchantPay from "@/pages/MerchantPay";
import StarCoin from "@/pages/StarCoin";
import { PaymentSuccess, PaymentCancel } from "@/pages/Stripe";
import { MerchantsPage } from "@/pages/Public";

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/" element={<Landing/>} />
          <Route path="/login" element={<AuthPage mode="login"/>} />
          <Route path="/register" element={<AuthPage mode="register"/>} />
          <Route path="/atm-locator" element={<AtmLocator/>} />
          <Route path="/status" element={<Status/>} />
          <Route path="/starcoin" element={<StarCoin/>} />
          <Route path="/merchants" element={<MerchantsPage/>} />
          <Route path="/pay/:sid" element={<MerchantPay/>} />
          <Route path="/payment/success" element={<PaymentSuccess/>} />
          <Route path="/payment/cancel" element={<PaymentCancel/>} />
          <Route path="/app/*" element={<Dashboard/>} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
